/* /*
 *###############################################################################
 *Module Name                   : InvoiceMasterContent.js                       #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               : Malisha Fernando                              #
 *Date                          : Friday, June 03th 2022                        #
 *Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */

import React, { useState, useEffect } from "react"
import { Col, Row, Alert, Button, Label } from "reactstrap"
import DPTextBox from "framework/components/DPTextBox"
import DPSearchBox from "framework/components/DPSearchBox"
import DPTextBoxforgrid from "framework/components/DPTextBoxforgrid"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import DPAlert from "../../../framework/widgets/DPAlert"
import { Numeric } from "../../../framework/validators/TextValidation"



const InvoiceMasterContent = ({
  Invoice_Value,
  Invoice_onChange,
  disabled,
  Invoice_OnBlur,
  DateOnBlur,
  DateonChange,
  DateValue,
  LocationOnChange,
  LocationValue,
  LocDesc,
  CusOnChange,
  CusValue,
  CusName,
  CashierOnChange,
  CashierValue,
  CashierName,
  InAmtValue,
  InAmtOnChange,
  PosValue,
  PosOnChange,
  RemarkOnChange,
  RemarkValue,
  menuName,
  modelOpen,
  modelTrigger,
  GetSelectRow,
  DataRow,
  disabledCode,
  AlertColor,
  AlertMsg,
  ErrorMsg,
  show,
  actualPaumentList
}) => {
  //*** useState to save table data */
  const [DataTables, SetDatatable] = useState([])


  async function tog_backdrop() {
    modelTrigger();
  }

  //modal props
  const columns = [{
    dataField: 'id',
    text: 'Id',
    sort: true,
  }, {
    dataField: 'invoice',
    text: 'Invoice',
    sort: true
  }, {
    dataField: 'customer',
    text: 'Customer',
    sort: true
  }, {
    dataField: 'cashier',
    text: 'Cashier',
    sort: true
  }];

  //default sorted method
  const defaultSorted = [{
    dataField: 'id',
    order: 'asc'
  }];


  return (
    <React.Fragment>
      <div>
        <Col sm="12">
          {show ? (
            <Alert color={AlertColor} role="alert">
              {AlertMsg}
              <br />
              <small>{ErrorMsg}</small>
            </Alert>
          ) : null}
          <Row>
            <Col sm={12} md={8} className="mb-4-sm">
              <Row>
                <Col sm={12} md={2} className="mb-4-sm">
                  <Label
                    htmlFor="example-text-input"
                    className={`col-md-12 col-form-label-sm`}

                  >Invoice No</Label>

                </Col>
                <Col sm={12} md={6} className="mb-4-sm">
                  <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    textType="text"
                    maxLength="20"
                    value={Invoice_Value}
                    onChange={Invoice_onChange}
                    onBlur={Invoice_OnBlur}
                    disabled={disabledCode}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={2} className="mb-4-sm">
                  <Label
                    htmlFor="example-text-input"

                    className={`col-md-12 col-form-label-sm`}
                  > Date</Label>

                </Col>
                <Col sm={12} md={3} className="mb-4-sm">
                  <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    textType="date"
                    maxLength="20"
                    value={DateValue}
                    onChange={DateonChange}
                    onBlur={DateOnBlur}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={2} className="mb-4-sm">
                  <Label
                    htmlFor="example-text-input"
                    className={`col-md-12 col-form-label-sm`}
                  >Customer</Label>
                </Col>
                <Col sm={12} md={3} className="mb-4-sm">
                  <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    textType="text"
                    maxLength="20"
                    value={CusValue}
                    onChange={CusOnChange}
                    disabled={true}
                  />
                </Col>
                <Col sm={12} md={3} className="mb-4-sm">
                  <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    labelText="Customer_name"
                    textType="text"
                    maxLength="50"
                    value={CusName}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={2} className="mb-4-sm">
                  <Label
                    htmlFor="example-text-input"
                    className={`col-md-12 col-form-label-sm`}
                  >Location</Label>
                </Col>
                <Col sm={12} md={3} className="mb-4-sm">
                  <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    textType="text"
                    maxLength="20"
                    value={LocationValue}
                    onChange={LocationOnChange}
                    disabled={true}
                  />
                </Col>
                <Col sm={12} md={3} className="mb-4-sm">
                  <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    labelText="Location_desc"
                    textType="text"
                    maxLength="30"
                    value={LocDesc}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={2} className="mb-4-sm">
                  <Label
                    htmlFor="example-text-input"
                    className={`col-md-12 col-form-label-sm`}
                  >Cashier
                  </Label>
                </Col>
                <Col sm={12} md={3} className="mb-4-sm">
                  <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    textType="text"
                    maxLength="20"
                    value={CashierValue}
                    onChange={CashierOnChange}
                    disabled={true}
                  />
                </Col>
                <Col sm={12} md={3} className="mb-4-sm">
                  <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    labelText="cashier_name"
                    textType="text"
                    maxLength="8"
                    value={CashierName}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={2} className="mb-4-sm">
                  <Label
                    htmlFor="example-text-input"
                    className={`col-md-12 col-form-label-sm`}
                  >POS Terminal
                  </Label>
                </Col>
                <Col sm={12} md={3} className="mb-4-sm">
                  <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    textType="text"
                    maxLength="20"
                    value={PosValue}
                    onChange={PosOnChange}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={2} className="mb-4-sm">
                  <Label
                    htmlFor="example-text-input"
                    className={`col-md-12 col-form-label-sm`}
                  >Invoice Amount
                  </Label>
                </Col>
                <Col sm={12} md={3} className="mb-4-sm">
                  <DPTextBoxforgrid
                    rowClass="mb-12-sm"
                    textType="text"
                    maxLength="20"
                    textAlign={'right'}
                    value={InAmtValue}
                    onChange={InAmtOnChange}
                    disabled={true}
                  />
                </Col>
              </Row>
            </Col>
            <Col sm={12} md={4} className="mb-4-sm">
              <table className="table table-striped table-bordered table-hover">
                <thead>
                </thead>
                <tbody>
                  {actualPaumentList.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{item.ph_desc}</td>
                        <td>{item.pd_desc}</td>
                        <td style={{ textAlign: "right" }}>{parseFloat(item.paid_amount).toFixed(2)}</td>
                      </tr>
                    )
                  }
                  )}
                </tbody>
              </table>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={8} className="mb-4-sm">
              <Row>
                <Col sm={12} md={8} className="mb-4-sm">
                  <DPTextBox
                    rowClass="mb-2-sm"
                    labelText="Remarks"
                    textType="text"
                    maxLength="50"
                    value={RemarkValue}
                    onChange={RemarkOnChange}
                    disabled={disabled}
                  />
                </Col>

                <DPSearchBox
                  searchData={DataTables}
                  columns={columns}
                  defaultSorted={defaultSorted}
                  mainTitle={menuName + " Search"}
                  SelectType={'radio'}//checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                  isOpen={modelOpen}
                  toggle={modelTrigger}
                  getSelect={GetSelectRow}
                />
              </Row>
            </Col>
          </Row>
        </Col >
      </div >
    </React.Fragment >
  )
}

export default InvoiceMasterContent


const TableRemRow = ({ FormRow, Key, RemoveRow, Disabled, menuCode }) => {
  const [Paycode, setPaycode] = useState(
    FormRow.Paycode != undefined ? FormRow.Paycode : ""
  )
  const [Paydesc, setPaydesc] = useState(
    FormRow.Paydesc != undefined ? FormRow.Paydesc : ""
  )

  const [PayDetcode, setPayDetcode] = useState(
    FormRow.PayDetcode != undefined ? FormRow.PayDetcode : ""
  )
  const [PayDetName, setPayDetName] = useState(
    FormRow.PayDetName != undefined ? FormRow.PayDetName : ""
  )
  const [PayAmount, setPayAmount] = useState(
    FormRow.PayAmount != undefined ? FormRow.PayAmount : "0.0"
  )
  const [AccountCode, setAccountCode] = useState(
    FormRow.AccountCode != undefined ? FormRow.AccountCode : ""
  )
  const [ReqDate, setReqDate] = useState(
    FormRow.ExpDate != undefined ? FormRow.ExpDate : ""
  )

  const [disableHed, setdisableHed] = useState(false)
  const [disableDet, setDisableDet] = useState(true)
  const [disableRef, setDisableRef] = useState(true)
  const [disableDate, setDisableDate] = useState(true)
  const [disableAmt, setDisableAmt] = useState(false)
  const [AlertConfirmOption, setAlertConfirmOption] = useState(0)
  const [sweetAlertShow, setsweetAlertShow] = useState(false)
  const [AlertDescription, setAlertDescription] = useState(false)
  const [searchBy, SetsearchBy] = useState("")
  const ApiURL = window.Links.ApiURL
  const [DataTablesPay, SetDatatablePay] = useState([])
  const [columnsPay, setColumnsPay] = useState([])
  const [columnsDetPay, setColumnsDetPay] = useState([])
  const [groupFilter, SetGroupFilter] = useState("a")

  const defaultSortedPay = [
    {
      dataField: "id",
      order: "asc",
    },
  ]
  const [modal_xlargePay, setmodal_xlargePay] = useState(false)
  const [modal_xlargePayDet, setmodal_xlargePayDet] = useState(false)
  function tog_xlargePay() {
    setmodal_xlargePay(!modal_xlargePay)
    removeBodyCss()
  }
  function tog_xlargePayDet() {
    setmodal_xlargePayDet(!modal_xlargePayDet)
    removeBodyCss()
  }
  //removebodyCss function
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  const clickPaySearch = async () => {
    tog_xlargePay()
  }
  const clickPaySearchDet = async () => {
    tog_xlargePayDet()
  }


  function CheckAccountNoLenth(PayDetcode, Accountno) {

  }

  //* Code Validation from repeating*/
  const CodeValidation = (strCode, id, strDetCode, Detid) => {
    var tbl = document.getElementById("PaymentDet")
    if (tbl != null) {
      let rowCount = tbl.tBodies[0].rows.length
      for (let i = 0; i < rowCount; i++) {
        var txtcode = document.getElementById("txtPaycode" + i)
        var txtPaydetCode = document.getElementById("txtPaydetCode" + i)
        if ("txtPaycode" + i != id && txtcode.value == strCode) {
          return false
        }
      }
    }
    return true
  }
  const GetSelectRowSupplier = (e, row, isSelect, rowIndex) => {

    if (CodeValidation(row.PH_CODE, "txtPaycode" + Key, "", "txtPaydetCode" + Key)) {
      if (row.PH_CHANGE == "True") {
        setPaycode(row.PH_CODE)
        SetGroupFilter(` AND PD_PHCODE = '${row.PH_CODE}' `)
        setPaydesc(row.PH_DESC)
        setDisableDet(row.PH_DETAILS == 1 ? false : true)
        setDisableRef(row.PH_DETAILS == 1 ? false : true)
        setPayDetcode(row.PH_DETAILS == 1 ? "" : row.PH_CODE)
        setPayDetName(row.PH_DETAILS == 1 ? "" : row.PH_DESC)
        setmodal_xlargePay(!modal_xlargePay)
        setdisableHed(true)
      } else {
        setsweetAlertShow(true)
        setAlertDescription("You can't change this payment Mode")
        setAlertConfirmOption(1)
      }
    } else {
      setAlertDescription("Payment Code already used")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
    }
  }
  const GetSelectRowPayDet = (e, row, isSelect, rowIndex) => {
    if (CodeValidation(Paycode, "txtPaycode" + Key, row.PD_CODE, "txtPaydetCode" + Key)) {
      setPayDetcode(row.PD_CODE)
      setPayDetName(row.PD_DESC)
      setDisableDate(row.PD_REQDATE == 1 ? false : true)
      setDisableAmt(row.PD_REQDATE == 1 ? true : false)
      setmodal_xlargePayDet(!modal_xlargePayDet)
      setDisableDet(true)
    } else {
      setAlertDescription("Payment Code already used")
      setAlertConfirmOption(4)
      setsweetAlertShow(true)
    }
  }

  const ValidateVoucherCode = (vouCode) => {
    if (vouCode.length > 0) {
      const ApiURL = window.Links.ApiURL
      const authToken = localStorage.getItem("authToken")
      var myHeaders = new Headers()
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${authToken}`);
      var data = []
      var requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
      }
      fetch(`${ApiURL}Common/voucher/${vouCode}`, requestOptions)
        .then(response => response.json())
        .then(result => {
          data = result.data
          if (data != "") {
            setAlertDescription(data)
            setAlertConfirmOption(4)
            setsweetAlertShow(true)
            setAccountCode("")
          }

        })
        .catch(error => console.log("error", error))
    }
  }

  return (
    <tr key={FormRow.id}>
      <td>{Key + 1}</td>
      <td style={{ width: "110px" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          maxLength="10"
          id={"txtPaycode" + Key}
          value={Paycode}
          disabled={Disabled ? true : disableHed}
          onChange={e => {
            setPaycode(e.target.value)
          }}
          onBlur={e => {
            if (CodeValidation(e.target.value, "txtPaycode" + Key, PayDetcode, "txtPaydetCode" + Key)) {
              //  ProductCodeSearch(e.target.value)
            } else {
              setAlertDescription("Payment Code already used")
              setAlertConfirmOption(4)
              setsweetAlertShow(true)
            }
          }}
        />
      </td>
      <td>
        <Button
          outline
          color="success"
          disabled={Disabled ? true : disableHed}
          id={"btnPaySearch" + Key}
          onClick={clickPaySearch}
          size="sm"
        >
          <i className="mdi mdi-search-web" style={{ fontSize: "12px" }}></i>
        </Button>
      </td>
      <td style={{ width: "200px" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          maxLength="8"
          id={"txtPaydesc" + Key}
          value={Paydesc}
          disabled={true}
          onChange={e => {
            setPaydesc(e.target.value)
          }}
        ></DPTextBoxforgrid>
      </td>
      <td style={{ width: "120px" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          maxLength="8"
          id={"txtPaydetCode" + Key}
          value={PayDetcode}
          disabled={disableDet}
          onChange={e => {
            setPayDetcode(e.target.value)
          }}
        ></DPTextBoxforgrid>
      </td>
      <td>
        <Button
          outline
          color="success"
          disabled={disableDet}
          id={"btnPayDetSearch" + Key}
          onClick={clickPaySearchDet}
          size="sm"
        >
          <i className="mdi mdi-search-web" style={{ fontSize: "12px" }}></i>
        </Button>
      </td>
      <td style={{ width: "200px" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          maxLength="8"
          id={"txtPayDetdesc" + Key}
          value={PayDetName}
          disabled={true}
          onChange={e => {
            setPayDetName(e.target.value)
          }}
        ></DPTextBoxforgrid>
      </td>
      <td style={{ width: "160px" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          maxLength="10"
          id={"txtAccountCode" + Key}
          value={AccountCode}
          disabled={disableRef}
          onChange={e => {
            setAccountCode(e.target.value)
          }}
          onBlur={e => {
            CheckAccountNoLenth(PayDetcode, e.target.value)
            ValidateVoucherCode(e.target.value)

          }}
        ></DPTextBoxforgrid>
      </td>
      <td style={{ width: "160px" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          textType="date"
          maxLength="10"
          id={"txtExpDate" + Key}
          value={ReqDate}
          disabled={disableDate}
          onChange={e => {
            setReqDate(e.target.value)
          }}
        ></DPTextBoxforgrid>
      </td>
      <td style={{ width: "145px" }}>
        <DPTextBoxforgrid
          rowClass="mb-12-sm"
          labelText="Code"
          textType="text"
          textAlign="right"
          disabled={Disabled ? true : disableAmt}
          id={"txtPayAmount" + Key}
          value={PayAmount}
          onChange={e => {
            let valPayAmount = Numeric(e.target, 8, 2, false)
            if (valPayAmount == "") {
              setPayAmount(0.0)
            } else {
              setPayAmount(Numeric(e.target, 8, 2, false))
            }
          }}
          onBlur={e => {
            let valPayAmount = Numeric(e.target, 8, 2, false)
            if (valPayAmount == "") {
              setPayAmount(0.0)
            } else {
              setPayAmount(parseFloat(valPayAmount, 10).toFixed(2))
            }
          }
          }

        ></DPTextBoxforgrid>
      </td>

      <td>
        <Button
          outline
          disabled={Disabled}
          color="danger"
          onClick={e => {
            RemoveRow(FormRow.id, Paycode, Paydesc)
          }}
          size="sm"
        >
          <i className="mdi mdi-delete" style={{ fontSize: "12px" }}></i>
        </Button>
      </td>

      <DPSearchBoxDynamic
        searchData={DataTablesPay}
        columns={columnsPay}
        defaultSorted={defaultSortedPay}
        mainTitle={"Payment Search"}
        SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
        isOpen={modal_xlargePay}
        toggle={tog_xlargePay}
        getSelect={GetSelectRowSupplier}
        APIURL={ApiURL}
        URLPath={"PAYMENT"}
        MenuCode={menuCode}
        KeyVal={"TXN"}
        searchBy={"PH_CODE"}
        FilterStr={groupFilter}
      />
      <DPSearchBoxDynamic
        searchData={DataTablesPay}
        columns={columnsDetPay}
        defaultSorted={defaultSortedPay}
        mainTitle={"Payment Detail Search"}
        SelectType={"checkbox"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
        isOpen={modal_xlargePayDet}
        toggle={tog_xlargePayDet}
        getSelect={GetSelectRowPayDet}
        APIURL={ApiURL}
        URLPath={"PAYMENTDET"}
        MenuCode={menuCode}
        KeyVal={"TXN"}
        searchBy={"PD_CODE"}
        FilterStr={groupFilter}
      />
      <DPAlert
        confirm_both={sweetAlertShow}
        title={"Invoice !"}
        description={AlertDescription}
        showCancel={false}
        btnColor={"success"}
        cancelColor={"danger"}
        onConfirm={() => {
          setsweetAlertShow(false)
          //  setPaycode("")
        }}
        btnYes={"OK"}
      />
    </tr>
  )
}
